export default {
  'promotionSettings.showPromotionsFirst': 'Create and display Promotions as the first category',
  'promotionSettings.showPromotionsFirst.description': '',
};
